import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { StyledTopStoriesBlock } from "~/components/section/default-section/styles";
import type { sectionSpotlightQuery$key } from "~/queries/__generated__/sectionSpotlightQuery.graphql";

import { Description, LogoContainer, StyledLogo, TopStoriesComponent } from "./styles";

type Props = {
  reference: sectionSpotlightQuery$key;
};

type Settings = {
  custom_text?: string;
};

const defaultCustomText =
  "Curated collections of our most-read stories, in-depth documentaries and more";

export const SectionSpotlight: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const { sectionSpotlightQueue } = useFragment(
    graphql`
      fragment sectionSpotlightQuery on Query
      @argumentDefinitions(sectionSpotlightQueueName: { type: "String!" }) {
        sectionSpotlightQueue: queue(filter: { name: $sectionSpotlightQueueName }) {
          settings
          items(first: 4) {
            edges {
              ...topStoriesBlockQueueItemsEdge
            }
          }
        }
      }
    `,
    reference_,
  );

  const sectionSpotlightItems = sectionSpotlightQueue?.items?.edges ?? [];
  const customText =
    (sectionSpotlightQueue?.settings as Settings)?.custom_text ?? defaultCustomText;

  return (
    <>
      <LogoContainer>
        <StyledLogo />
        <Description>{customText}</Description>
      </LogoContainer>
      <TopStoriesComponent>
        <StyledTopStoriesBlock
          reference={sectionSpotlightItems}
          onClick={() => {
            // todo: add tracking
          }}
        />
      </TopStoriesComponent>
    </>
  );
};

SectionSpotlight.displayName = "SectionSpotlight";
